import { isDesktop } from '@/lib/desktop'
import styles from './DesktopTitlebar.module.css'

/**
 * Полоса для перетаскивания окна на экранах без нашей шапки (главная, вход, публичный каталог).
 * В приложении системной полосы нет, поэтому окно нужно за что-то тянуть; в браузере ничего не рисуем.
 */
export function DesktopTitlebar() {
  if (!isDesktop) return null
  return <div className={styles.strip} aria-hidden="true" />
}
